const storeModel = {};

export default storeModel;
